import { getUserInitials, Icons } from "../../../utils";

/* ================================================================
   AVAILABLE USER CHIP - Chip compact utilisateur
================================================================ */
export default function AvailableUserChip({ user, onAdd }) {
  return (
    <button
      type="button"
      className="available-user-chip"
      onClick={onAdd}
      title={`${user.first_name} ${user.last_name} - ${user.email}`}
    >
      <div className="user-avatar-sm">{getUserInitials(user)}</div>
      <span className="user-name-compact">
        {user.first_name} {user.last_name}
      </span>
      <Icons.Add className="add-icon" />
    </button>
  );
}
